import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import { TLanguageSections, TOnClick } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import React from "react"
import AdminPanelFormHeader, { THeaderButtonsType } from "./AdminPanelFormHeader"

interface Props {
	buttonsType: THeaderButtonsType
	title: string
	language?: TLanguageSections
	tooltipText?: string
	onClickAddField?: TOnClick<HTMLButtonElement>
	onClickPreview?: TOnClick<HTMLButtonElement>
	onClickDeleteFields?: TOnClick<HTMLButtonElement>
	onClickConnect?: TOnClick<HTMLButtonElement>
	children?: React.ReactNode
}

const AdminPanelFormSection = ({
	language,
	buttonsType,
	title,
	tooltipText,
	onClickAddField,
	onClickPreview,
	onClickDeleteFields,
	onClickConnect,
	children,
}: Props) => {
	const { isMobile } = useScreenType()

	return (
		<div>
			<AdminPanelFormHeader
			    language={language}
				buttonsType={buttonsType}
				title={title}
				tooltipText={tooltipText}
				onClickAddField={onClickAddField}
				onClickPreview={onClickPreview}
				onClickDeleteFields={onClickDeleteFields}
				onClickConnect={onClickConnect}
			/>
			<HyperDiv padding={isMobile ? undefined : "0 2rem 2rem"}>{children}</HyperDiv>
		</div>
	)
}

export default AdminPanelFormSection
